module.exports = __webpack_public_path__ + "img/背景.4634b381.png";